import request from "../request"
const server = {
    queryMemberPage:function (params) {
        return request.post('user-center/log/queryMemberPage',params)
    },
    queryRolePage:function (params) {
        return request.post('ubm/log/queryRolePage',params)
    },
    queryAuthorityPage:function (params) {
        return request.post('ubm/log/queryAuthorityPage',params)
    },
    queryProductLogByPage:function (params) {
        return request.post('product/productLog/queryProductLogByPage', params)
    },
    queryLogListByPage:function (params) {
        return request.post('transaction-center/OrderLog/queryLogListByPage', params)
    },
}
export default server